import ImageLoader from '../components/ImageLoader'


export default function(){
    return (
        <div>
            <ImageLoader src={require("../images/location/bkg--location-aerial.jpg").default} />
        </div>
    )
}